import { mountListener, mountListenerWhen, type EventListener } from "../event"
import type { ActionBindingEvent } from "./ActionBindingEvent.type"
import getInputActionListenerList from "./getInputActionListenerList"
import type { InputActionType } from "./InputActionType"

export function mountInputActionListener(
  action: InputActionType,
  fn: EventListener<ActionBindingEvent>,
): void {
  mountListener(getInputActionListenerList(action), fn)
}

export function mountInputActionListenerWhen(
  action: InputActionType,
  when: () => unknown,
  fn: EventListener<ActionBindingEvent>
): void {
  mountListenerWhen(getInputActionListenerList(action), when, fn)
}
